import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { DebugToolsToggle } from "./components/dev/DebugToolsToggle";
import { AuthProvider } from "./components/auth/AuthProvider";
import { AuthGate } from "./components/auth/AuthGate";

// B8: PasswordGate removido. AuthProvider + AuthGate son el único gate.
// AuthGate decide si renderea children o redirige a /login según
// status + ruta (ver components/auth/AuthGate.tsx para whitelist de
// rutas públicas).
//
// DebugToolsToggle se renderiza fuera del router para que aparezca en
// todas las rutas sin tener que tocar cada layout. El botón es `fixed`
// → no interfiere con el layout de la ruta activa. Queda dentro del
// gate para que no se vea sin autenticación.

export default function App() {
  // One-shot cleanup del session marker del PasswordGate eliminado en B8.
  // Sin esto, el localStorage queda con la key huérfana hasta que el
  // browser limpie storage por sí mismo. No afecta funcionamiento pero
  // mantiene el storage limpio para users que venían de pre-B8.
  useEffect(() => {
    try {
      window.localStorage.removeItem("gonix_session_token");
    } catch {
      /* storage access denied — no pasa nada */
    }
  }, []);

  return (
    <AuthProvider>
      <AuthGate>
        <RouterProvider router={router} />
        <DebugToolsToggle />
      </AuthGate>
    </AuthProvider>
  );
}
